import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EAndOAgency } from '../models/eando/eando-agency.model';
import { EAndOAttachment } from '../models/eando/eando-attachment';
import { EAndOCarrier } from '../models/eando/eando-carrier.model';
import { EAndONote } from '../models/eando/eando-note.model';
import { EAndO } from '../models/eando/eando.model';
import { SearchEAndO } from '../models/eando/search-eando.model';
import { AuthService } from '../services';
import { ApiClientService } from './common/api-client.service';

@Injectable({
  providedIn: 'root'
})
export class EandoService {

  constructor(private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient) { }

  getEAndOByTenantId(search: SearchEAndO, initLoad: boolean = true): Observable<EAndO[]> {
    return this.apiClient.post(`api/eando/getEAndOList`, search, null, initLoad);
  }

  getEAndOAgencies(search: SearchEAndO): Observable<EAndOAgency[]> {
    return this.apiClient.post(`api/eando/getEAndOAgencies`, search, null, false);
  }

  getEAndOCarriers(search: SearchEAndO): Observable<EAndOCarrier[]> {
    return this.apiClient.post(`api/eando/getEAndOCarriers`, search, null, false);
  }

  getEAndODetail(eandoId: number): Observable<EAndO> {
    return this.apiClient.get(`api/eando/getEAndODetail/${eandoId}`);
  }

  getEAndONotes(eandoId: number): Observable<EAndONote[]> {
    return this.apiClient.get(`api/eando/getEAndONotes/${eandoId}`);
  }

  getEAndOAttachments(eandoId: number, archive: boolean): Observable<EAndOAttachment[]> {
    return this.apiClient.get(`api/eando/getEAndOAttachments/${eandoId}/${archive}`);
  }

  insertEAndO(eando: EAndO, files: any[]): Observable<any> {
    const formData = new FormData();
    formData.append('eandoJson', JSON.stringify(eando));

    files.forEach((_file) => {
      if (_file.file) {
        formData.append('files', _file.file, _file.fileName);
      }
    });

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/eando/insertEAndO`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  insertEAndOCarrier(eandoCarrier: EAndOCarrier): Observable<number> {
    return this.apiClient.post(`api/eando/insertEAndOCarrier`, eandoCarrier);
  }

  insertEAndOAgency(eandoAgency: EAndOAgency): Observable<number> {
    return this.apiClient.post(`api/eando/insertEAndOAgency`, eandoAgency);
  }

  updateEAndO(eando: EAndO): Observable<any> {
    const formData = new FormData();
    formData.append('eandoJson', JSON.stringify(eando));

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/eando/updateeando`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  insertEAndONote(eandoNote: EAndONote): Observable<number> {
    return this.apiClient.post(`api/eando/insertEAndONote`, eandoNote);
  }

  downloadEAndOFile(eandoAttachmentId: number): Observable<any> {
    return this.apiClient.get(`api/eando/downloadEAndOFile/${eandoAttachmentId}`, null, null, false);
  }

  uploadEAndOAttachments(eandoId: number, formData: FormData): Observable<number> {
    const headers = new HttpHeaders().append('enctype', 'multipart/form-data');
    return this.apiClient.post(`api/eando/uploadEAndOAttachments/${eandoId}`, formData, headers);
  }

  deleteEandOAttachment(eandoAttachmentId) {
    var requestUrl = `api/eando/deleteEandOAttachment/${eandoAttachmentId}`;
    return this.apiClient.delete(requestUrl, null, null, true);
  }

  archiveEandOAttachment(eandoAttachmentId) {
    var requestUrl = `api/eando/archiveEandOAttachment/${eandoAttachmentId}`;

    return this.apiClient.post(requestUrl, null, null, true);
  }

  archiveEandO(eandoId) {
    var requestUrl = `api/eando/archiveEandO/${eandoId}`;

    return this.apiClient.post(requestUrl, null, null, true);
  }

  unarchiveEandOAttachment(eandoAttachmentId) {
    var requestUrl = `api/eando/unarchiveEandOAttachment/${eandoAttachmentId}`;

    return this.apiClient.post(requestUrl, null, null, true);
  }

  checkRecordNumberExists(recordNumber:string, eandoTypeId: number,eandoId :number){
    return this.apiClient.get(`api/EAndO/CheckRecordNumberExists/${recordNumber}/${eandoTypeId}/${eandoId}`, null, null, false);
  }

  unarchiveEandO(eandoId:number)
  {
    return this.apiClient.post(`api/EAndO/unArchiveEandO/${eandoId}`,null, null, true)
  }
}
